/**
 * State used in rendering Spinner
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
